// extracted by mini-css-extract-plugin
export default {"container":"fFIve4","description":"Hgxwhw","descriptionOutbound":"OTvk8W","buttonLabel":"yUjTBv","button":"hghi42","descriptionText":"PUkgdf","wrapperLink":"zkEUI9"};